import { createContext } from 'react';

const ToggleContext = createContext(null);

export default ToggleContext;
